// The audio-FX rack: every music-driven effect as a discrete, individually
// toggleable unit with its own intensity dial. This is COARSE config (user
// dials, a few changes a minute) so it lives in React state and flows to the
// fields as a prop; the per-frame magnitudes still come from `audioBus`
// (off-React) — the fields read both through refs inside useFrame.

export type FxUnit = { on: boolean; amt: number };

export type AudioFX = {
  /** Glow + point-size swell on energy and beats (shader, both physics). */
  pulse: FxUnit;
  /** The inflating random subset — "one set repels to max, the swarm adapts"
   *  (neighbor physics). `frac` = fraction of the swarm in the set. */
  push: FxUnit & { frac: number };
  /** The two travelling bass plane waves — undulation across the shape
   *  (neighbor physics). */
  waves: FxUnit;
  /** Beat-spawned expanding ripple shells (neighbor physics). */
  ripples: FxUnit;
  /** Bass breathes the whole swarm's size (both physics). */
  swell: FxUnit;
  /** Bass torques the swarm around the vertical axis (both physics). */
  spin: FxUnit;
  /** Treble makes the drones sparkle — deeper, faster twinkle (shader). */
  shimmer: FxUnit;
  /** The palette drifts around the hue wheel with the music (shader). */
  hue: FxUnit;
};

export const DEFAULT_FX: AudioFX = {
  pulse: { on: true, amt: 1 },
  push: { on: true, amt: 1, frac: 0.15 },
  waves: { on: true, amt: 1 },
  ripples: { on: true, amt: 1 },
  swell: { on: true, amt: 1 },
  spin: { on: true, amt: 0.5 },
  shimmer: { on: true, amt: 1 },
  hue: { on: false, amt: 0.5 }, // recolors the user's chosen palette — opt-in
};
